export default "__VITE_ASSET__C_6ti4F1__"